import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {DbService} from 'src/app/services/db-service/db.service';
import {PaymentsService} from 'src/app/services/payment_apis/payments.service';
import {SubscriptionService} from 'src/app/services/subscription.service';
import {environment} from 'src/environments/environment';
import {cashfreeProd, cashfreeSandbox} from "cashfree-pg-sdk-javascript";
import { PriceBreakdownComponent } from '../price-breakdown/price-breakdown.component';

@Component({
  selector: 'app-pricing-details',
  templateUrl: './pricing-details.component.html',
  styleUrls: ['./pricing-details.component.scss'],
  standalone: true,
  imports: [MatIconModule, FormsModule, CommonModule]
})
export class PricingDetailsComponent {
  twoButtons = [
    {
      name: 'monthly',
      status: false,
      value: 'MONTHLY'
    },
    {
      name: 'yearly',
      status: true,
      value: 'ANNUALLY'
    }
  ];
  subscriptionpoints: any = ["Extend your limit upto 50 new creations", "You can create muliple Businesses", "Enjoy without any limits"]
  features: any = []
  subscriptionType: 'MONTHLY' | 'ANNUALLY' = 'ANNUALLY';
  pricingSubscription?: Subscription;
  pricingData: any;
  planSubscription?: Subscription;
  planList: any[] = []

  constructor(private close: MatDialogRef<PricingDetailsComponent>,
              private router: Router,
              private SubscriptionService: SubscriptionService,
              private _paymentService: PaymentsService,
              private _snackbar: MatSnackBar,
              private _dbService: DbService,
              public dialogRef: MatDialogRef<PricingDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.getAllPlans();
  }

  ngOnDestroy() {
    this.pricingSubscription?.unsubscribe();
  }

  closeDialog() {
    this.close.close();
  }

  navigateToUpgradePage() {
    this.close.close();
    this.router.navigate(['/admin/account/subscriptions'])
  }

  getAllPricingDetails() {
    this.pricingSubscription = this.SubscriptionService.getNextplanFeatures().subscribe(
      (res: any) => {
        this.pricingData = res.plan;
        this.features = this.pricingData.planFeaturesList?.split(",")
      }
    )
  }

  isCustomPlan : boolean = false;

  getAllPlans() {
    this.planSubscription = this.SubscriptionService.getSubscriptionDetails().subscribe((res: any) => {
      // console.log(res.data)
      if(this.data.plan != null){
        res.data.forEach(element => {
          if(element.plan.id === this.data.plan.paidPlanId && element.plan.planName.split(' ').join('_') === 'AI_Growth_Partner'){
            this.isCustomPlan = true;
          }
          else if (element?.plan?.planName?.split(' ').join('_') != 'AI_Jumpstart') {
            this.planList.push(element)
          }
        });
      }
      else{
        this.planList = res.data;
        this.isCustomPlan = false;
      }
      this.planList?.forEach((plan: any) => {
        plan['subscription'] = false;
        plan['features'] = plan?.plan?.planFeaturesList?.split(",");
      })


    })
  }

  upgradeCustomPlan(TYPE:any){
    // let data : any ={
    //   businessId: this._dbService.getBusinessId(),
    //   subscriptionId: this.data.plan.paidPlanId,
    //   isMonthly: TYPE === 'MONTHLY' ? true : false,
    //   domain: `${environment.redirectingUrl}`,
    //   affiliatePartnerKey: ""
    // }
    // if (localStorage.getItem("partnerId")) {
    //   data.affiliatePartnerKey = localStorage.getItem("partnerId")
    // }

    // this._paymentService.subscribePlan(data).subscribe(
    //   (res: any) => {
    //     // window.location.href = `${res.data.url}`
    //     const paymentSessionId = res.data.url;
    //     this._dbService.setPaymentId(res.data.paymentId);
    //     window.localStorage.setItem('endDate', res.data.endDate);
    //     window.localStorage.setItem('planName', res.data.planName);
    //     window.localStorage.setItem('planAmount', res.data.planAmount);

    //     let cashFree;
    //     if (environment.production)
    //       cashFree = new cashfreeProd.Cashfree(paymentSessionId)
    //     else
    //       cashFree = new cashfreeSandbox.Cashfree(paymentSessionId);

    //     cashFree.redirect();
    //   },
    //   (err) => {
    //     this._snackbar.open(
    //       `${err.error.message}`,
    //       'Close',
    //       {
    //         duration: 1500
    //       }
    //     );
    //   }
    // )
     let data = {
      businessId:this._dbService.getBusinessId(),
      planId:this.data.plan.paidPlanId,
      intervalType: TYPE === 'ANNUALLY' ? 'Year' : 'Month',
       completePayment: false
    }

    this._paymentService.subscribeAutoPay(data).subscribe({
      next:(res:any) => {
        // console.log(res.data)
        // let authLink = res?.data.authLink?.replace(/^"|"$/g, '').trim();

        // if (authLink) {
        //   window.location.href = authLink; // redirects to Cashfree
        // } else {
        //   console.error('Auth link missing in response');
        // }
        let pricingDetails = this.SubscriptionService.openDialog(PriceBreakdownComponent, 'auto', '30vw', {data:res.data,actualPlanAmount:TYPE === 'ANNUALLY' ? this.data.plan?.customYearly : this.data.plan?.customMonthly});
        pricingDetails.afterClosed().subscribe((res: any) => {
        })
        window.localStorage.setItem('planName', this.data.plan?.plan?.planName);
        window.localStorage.setItem('planAmount', this.subscriptionType === 'ANNUALLY' ? this.data.plan?.prices?.yearlySellingPrice : this.data.plan?.prices?.monthlySellingPrice);
        // window.localStorage.setItem('priceDetails',res.data)
      },
      error:(err:any) => {
        // console.log(err.error)
        this._snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        );
      }
    })


  }


  //One time Payment
  // upgradePlan(plan: any) {

  //   let data: any = {
  //     businessId: this._dbService.getBusinessId(),
  //     subscriptionId: plan.plan.id,
  //     isMonthly: this.subscriptionType === 'MONTHLY',
  //     domain: `${environment.redirectingUrl}`,
  //     affiliatePartnerKey: ""
  //   }
  //   if (localStorage.getItem("partnerId")) {
  //     data.affiliatePartnerKey = localStorage.getItem("partnerId")
  //   }

    // this._paymentService.subscribePlan(data).subscribe(
  //     (res: any) => {
  //       // window.location.href = `${res.data.url}`
  //       const paymentSessionId = res.data.url;
  //       this._dbService.setPaymentId(res.data.paymentId);
  //       window.localStorage.setItem('endDate', res.data.endDate);
  //       window.localStorage.setItem('planName', res.data.planName);
  //       window.localStorage.setItem('planAmount', res.data.planAmount);

  //       let cashFree;
  //       if (environment.production)
  //         cashFree = new cashfreeProd.Cashfree(paymentSessionId)
  //       else
  //         cashFree = new cashfreeSandbox.Cashfree(paymentSessionId);

  //       cashFree.redirect();
  //     },
  //     (err) => {
  //       this._snackbar.open(
  //         `${err.error.message}`,
  //         'Close',
  //         {
  //           duration: 1500
  //         }
  //       );
  //     }
  //   )
  // }

  //Auto Pay

  upgradePlan(plan:any){
    let data = {
      businessId:this._dbService.getBusinessId(),
      planId:plan.plan.id,
      intervalType: this.subscriptionType === 'ANNUALLY' ? 'Year' : 'Month',
       completePayment: false
    }

    this._paymentService.subscribeAutoPay(data).subscribe({
      next:(res:any) => {
        // let authLink = res?.data.authLink?.replace(/^"|"$/g, '').trim();

        // if (authLink) {
        //   window.location.href = authLink; // redirects to Cashfree
        // } else {
        //   console.error('Auth link missing in response');
        // }
        let pricingDetails = this.SubscriptionService.openDialog(PriceBreakdownComponent, 'auto', '30vw', {data:res.data,actualPlanAmount:this.subscriptionType === 'ANNUALLY' ? plan?.prices?.yearlyPrice : plan?.prices?.monthlyPrice});
        pricingDetails.afterClosed().subscribe((res: any) => {
        })
        window.localStorage.setItem('planName', plan?.plan?.planName);
        window.localStorage.setItem('planAmount', this.subscriptionType === 'ANNUALLY' ? plan?.prices?.yearlySellingPrice : plan?.prices?.monthlySellingPrice);
        // window.localStorage.setItem('priceDetails',res.data)
      },
      error:(err:any) => {
        // console.log(err.error)
        this._snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        );
      }
    })
  }

  closeWindow() {
    this.dialogRef.close()
  }

  changeSubscriptionType(type) {
    this.subscriptionType = type.value
  }

  contactUs() {
    window.open('https://simpo.ai/contact', '_blank')
  }

  showAll = false;

  toggleShowAll() {
    this.showAll = !this.showAll;
  }
}
